
import React from "react";
import moment from "moment-timezone";
import { Row, Col, Card } from '@themesberg/react-bootstrap';

export default (props) => {
  const currentYear = moment().get("year");

  return (
    <div>
      <footer className="footer section py-5">
        <Row>
          <Col xs={12} className="text-center">
            <p className="mb-0 text-muted">
              © {currentYear} Pinki — Tüm hakları saklıdır.
            </p>
          </Col>
        </Row>
      </footer>
    </div>
  );
};
